export default __webpack_public_path__ + "static/media/search.bbe0e08d.png";